import { app } from '../../../bootstrap/core';
import { oldBankInputComponent } from './oldBankInput.component';

app.component('oldBankInput', oldBankInputComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/oldBankInput/oldBankInput.js